<template>
  <AnimationComponent>
    <SectionWithCarousel
      :tag="tag"
      :title="title"
      :titleImage="titleImage"
      :description="description"
      :items="features"
    >
      <template #card="{ item }">
        <FeatureCard
          :icon="item.image || (item.icon ? getIconComponent(item.icon) : '')"
          :title="item.title"
          :description="item.description"
          :hasButton="hasButton && !!item.buttonLabel"
          :buttonLabel="item.buttonLabel"
          :buttonStyle="item.buttonStyle"
          :buttonLink="item.buttonLink"
          :style="cardStyle"
          class="basis-full shrink-0 grow-0"
        />
      </template>
    </SectionWithCarousel>
  </AnimationComponent>
</template>

<script setup lang="ts">
import { getIconComponent } from '@/utils/icons';
import { computed } from 'vue';
import AnimationComponent from '../AnimationComponent.vue';
import FeatureCard from './FeatureCard.vue';
import SectionWithCarousel from './SectionWithCarousel.vue';

export interface Feature {
  icon?: string;
  image?: string;
  title: string;
  description: string;
  buttonLabel?: string;
  buttonStyle?: 'outline-light' | 'default' | 'destructive' | 'outline' | 'ghost' | 'link' | 'greyed' | 'secondary';
  buttonLink?: string;
}

interface Props {
  tag?: string;
  title?: string;
  titleImage?: string;
  description?: string;
  features: Feature[];
  hasButton?: boolean;
  itemsPerRow?: number;
}
const props = withDefaults(defineProps<Props>(), {
  tag: '',
  title: '',
  titleImage: '',
  description: '',
  itemsPerRow: 3,
});

const cardStyle = computed(() => {
  const percentage = (100 / props.itemsPerRow).toFixed(3);
  return {
    flexBasis: `calc(${percentage}% - 2rem)`,
  };
});
</script>
